import styled, { css } from '@xstyled/styled-components';
import { CarouselVariants } from '../CarouselStore';

export const Wrapper = styled.divBox<{ variant: CarouselVariants }>`
  display: grid;
  width: 100%;
  min-height: 100%;
  overflow: hidden;

  h1 {
    margin-top: 30px;
    line-height: 24px;
    font-size: 24px;
  }

  ${p => {
    switch (p.variant) {
      case 'horizontal':
        return css`
          min-height: 0;
          grid-template-columns: 1fr 51px auto 51px 1fr;
          grid-template-rows: 1fr auto auto 1fr;
          grid-template-areas:
            '. . . . .'
            '. item item item .'
            '. prev progress next .'
            '. . . . .';

          @media (min-width: lg) {
            grid-template-areas:
              '. . . . .'
              '. prev item next .'
              '. prev progress next .'
              '. . . . .';
          }
        `;
      case 'vertical':
        return css`
          grid-template-columns: 1fr auto 1fr;
          grid-template-rows: 1fr auto auto 1fr;
          grid-template-areas:
            '. prev .'
            'item item item'
            'item item item'
            '. next .';

          @media (min-width: lg) {
            grid-template-areas:
              '. . .'
              '. item prev'
              '. item next'
              '. . .';
          }
        `;
      case 'stack':
        return css`
          grid-template-columns: 1fr;
          grid-template-rows: 1fr 4fr;
          grid-template-areas:
            '. prev .'
            'item item item'
            'item item item'
            '. next .';
        `;
      case 'grid':
        return css`
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: md;
        `;
      case 'dynamic':
        return css`
          padding-bottom: 50px;
          display: flex;
          justify-content: center;
          overflow: visible;
          flex-wrap: wrap;
          min-height: 80%;
          height: 80%;
        `;
    }
  }}
`;
